import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { CourseProvider } from "./context/CourseContext";

import "./index.css";

import App from "./App";

import "./index.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { LanguageProvider } from "./context/langContext";
import { QueryClientProvider, QueryClient } from "react-query";

// Create a client
const queryClient = new QueryClient();

ReactDOM.render(
  <BrowserRouter>
    <CourseProvider>
      <LanguageProvider>
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      </LanguageProvider>
    </CourseProvider>
  </BrowserRouter>,
  document.getElementById("root")
);
